const api_config = require("./api_config");

//const rax = require('retry-axios');
const axios = require("axios");

const AmazonCognitoIdentity = require('amazon-cognito-identity-js');


const api = axios.create({
  baseURL: `${api_config.api_url}`,
  headers: {
    "content-type": "application/json"
  }
});

api.defaults.timeout = 20000;


const getUserPool = (isGuest = false) => {
  return new AmazonCognitoIdentity.CognitoUserPool({
    UserPoolId: isGuest ? api_config.cognito_guestUserPoolId : api_config.cognito_userPoolId,
    ClientId: isGuest ? api_config.cognito_guestUserPoolWebClientId : api_config.cognito_userPoolWebClientId,
  });
}

const getCurrentUser = () => getUserPool(false).getCurrentUser() || getUserPool(true).getCurrentUser();

const removeCognitoLocalStorageEntries = () => {
    const arr = []; // Array to hold the keys
    for (let i = 0; i < window.localStorage.length; i++){
        if (window.localStorage.key(i).includes('CognitoIdentityServiceProvider') ) {
            arr.push(window.localStorage.key(i));
        }
    }

    for (const arrElement of arr) {
        window.localStorage.removeItem(arrElement);
    }
}

const getSessionFromUser = (cognitoUser) => {
  return new Promise((resolve, reject) => {
      cognitoUser.getSession((err, session) => {
          try{
              if (err) {
                  if (err.message.includes("Cannot retrieve a new session")) {
                      removeCognitoLocalStorageEntries();
                      window.location.href = window.location.pathname + window.location.search + window.location.hash;
                  }
              }
              else return resolve(session)
          } catch (err) {
              reject(err)
          }
      })
  })
}

const getJwtToken = async () => {
    let jwtToken;

    try {
        const cognitoUser = getCurrentUser();
        if (cognitoUser) {
            const session = await getSessionFromUser(cognitoUser);
            if (session) {
                jwtToken = session.getAccessToken().getJwtToken();
            }
        }
    } catch (err) {
        console.error("carbon-api-client Authentication error", err);
    }

    return jwtToken;
}

const checkJwtToken = async () => {
    const jwtToken = await getJwtToken();

    return !!jwtToken;
}

api.interceptors.request.use(async apiConfig => {

    const carbon_app_api_key = api_config.carbon_app_api_key;
    const jwtToken = await getJwtToken();

    let theseHeaders = Object.assign(apiConfig.headers, {
        "x-api-key": `${carbon_app_api_key}`
    });
    if (jwtToken) {
        theseHeaders = Object.assign(apiConfig.headers, {
            Authorization: `Bearer ${jwtToken}`
        });
    } else {
        console.log(`Could not load token, local storage size is: ${localStorage.length}`);
    }

    return Object.assign(apiConfig, {headers: theseHeaders});
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  error => {
    throw { error, type: "error", status: (error.status || (error.response && error.response.status)) };
  }
);

async function handleResponse(response) {
  if (
    response.status === 200 &&
    response.config &&
    response.config.method === "head"
  )
    return await response.status;
  if (response.status === 200) return await response.data;
  if (response.status === 204) return response.status;
  if (response.status === 201) return await response.data;
  if (response.ok) return await response.json();

  throw response.status;
}

async function handleError(error) {
  throw { error, type: "error" };
}

module.exports = {
  api,
  handleResponse,
  handleError,
  checkJwtToken
};
